import './Firstfloor.css'
import Footer from '../../components/Footer/Footer.jsx';
import ImageCard from '../../components/ImageCard/ImageCard.jsx';
import chillzone1 from '../../images/Cab_photos/chill_zone/IMG20250325112530.jpg'
import chillzone2 from '../../images/Cab_photos/chill_zone/IMG20250325105405.jpg'
import cab_1_1 from '../../images/Cab_photos/cab_1/IMG20250325112040.jpg'
import cab_2_2 from '../../images/Cab_photos/cab_2/IMG20250325112334.jpg'
import cab_3_2 from '../../images/Cab_photos/cab_3/IMG20250325105849.jpg'
import dinning_room from '../../images/Cab_photos/dining_room/1.jpg'
import dinning_room2 from '../../images/Cab_photos/dining_room/2.jpg'
import cab_6_1 from '../../images/Cab_photos/cab_6/IMG20250325112153.jpg'
import library1 from '../../images/Cab_photos/library/1.jpg'
import library2 from '../../images/Cab_photos/library/2.jpg'
import cab_5_1 from '../../images/Cab_photos/cab_5/1.jpg'
import cab_4_1 from '../../images/Cab_photos/cab_4/1.jpg'
import inform_1 from '../../images/Cab_photos/inform/1742983284741.jpg'
import inform_2 from '../../images/Cab_photos/inform/1742983284750.jpg'
import mastersk_1 from '../../images/Cab_photos/mastersk/1742984662431.jpg'
import mastersk_2 from '../../images/Cab_photos/mastersk/1742984662437.jpg'
import psyhology1 from '../../images/Cab_photos/psyhology/1743065501578.jpg'
import psyhology2 from '../../images/Cab_photos/psyhology/1743065501588.jpg'
import psyhology3 from '../../images/Cab_photos/psyhology/1743065501594.jpg'
import { Link } from 'react-router-dom';

function Firstfloor() {
  return (
    <>
      <div className='wrap'>
        <div className="Firstfloor">
          <ImageCard 
            title={'Зона отдыха "Под лестницей"'} 
            images={[chillzone1, chillzone2]}
            description={'Это место, где ученики могут отдохнуть, пообщаться с друзьями и интересно провести время на переменах или после уроков'}
          />

          <ImageCard 
            title={'Библиотека'} 
            images={[library1, library2]}
            description={'Наша библиотека разделена на несколько зон. Абонемент, где выдают книги на дом. Зона свободного доступа, где ученики разных классов могут свободно выбирать книги с полок. Хранилище для учебной литературы. Читальный зал, где есть медиаоборудование: проектор, экран, компьютер. Зал используют для библиотечных уроков, мероприятий, работы с научно-популярной литературой.'}
          />

          <ImageCard 
            images={[psyhology2,psyhology1 , psyhology3]}
            description={'Сюда приходят, если нужно поговорить с психологом, провести развивающее занятие и разрешить конфликт, а ещё здесь проходит игротека. Каждый ученик и сотрудник школы может получить помощь нашего психолога.'}
            title={'Кабинет психолога'}
          />

          <ImageCard 
            title={'Кабинеты начальных классов'} 
            images={[cab_1_1, cab_2_2, cab_3_2, cab_4_1, cab_5_1, cab_6_1]} 
            description={'Это специально оборудованные классные комнаты, где проводятся уроки и внеурочные мероприятия для младших школьников. Кабинеты оснащены необходимыми средствами обучения, которые используются в соответствии с учебниками и программами: карты по окружающему миру, альбомы по изобразительному искусству, таблицы, схемы по математике, технические средства обучения и другие. Слева на стендах располагаются таблицы по изучаемым темам, классные уголки, уголки с символикой России'}
          />

          <ImageCard 
            title={'Столовая'} 
            images={[dinning_room2, dinning_room]}
            description={'Если спросить учеников или сотрудников про их любимое место в школе, то многие ответят, что это столовая. На завтрак и обед у нас есть большой выбор блюд, которые подходят для людей с разными пищевыми ограничениями. Всё питание готовится на школьной кухне, что позволяет лучше следить за качеством еды.'}
          />

          <ImageCard 
            title={'Кабинет информатики'} 
            images={[inform_1, inform_2]}
            description={'Это класс с удобной мебелью, компьютерами и другим технологическим оборудованием. Там находится необходимое количество справочной литературы, учебных пособий для учащихся 5 - 11 классов, методических пособий для учителей информатики, литературы, необходимой для учебной программы по информатике.'}
          />

          <ImageCard 
            title={'Мастерская'} 
            images={[mastersk_1, mastersk_2]}
            description={'Здесь мальчики учатся создавать своими руками различные изделия из дерева, глины, металла. Приобретают навыки работы с ручным инструментом, учатся безопасно пользоваться столярными станками, осваивают основные приёмы плотницкого дела.'}
          />
        </div>
        <div className="next-floor-button-container">
            <Link to="/Secondfloor" className="next-floor-button">
              Перейти на 2 этаж →
            </Link>
        </div>
      </div>
      <Footer/>
    </>
  );
}

export default Firstfloor;